"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSearchQuery = exports.buildEvaluationQuery = exports.buildQueryTemplate = exports.buildTrainTest = exports.buildConverter = void 0;
const lodash_1 = __importDefault(require("lodash"));
const AitoEvaluateResults_1 = require("../aito/AitoEvaluateResults");
function buildFrom(data) {
    if (data.type === 'instance') {
        return {
            from: data.tableName,
        };
    }
    else {
        throw new Error(`Unknown DataSource type: ${data.type}`);
    }
}
function convertTo(dataType) {
    switch (dataType) {
        case 'boolean':
            return v => Boolean(v);
        case 'decimal':
            return v => Number(v);
        case 'int':
        case 'long':
            return v => Math.floor(Number(v));
        case 'text':
        case 'string':
            return v => String(v);
    }
}
function buildConverter(configuration) {
    const fields = configuration.inputColumns.map(({ name, data }) => {
        const castToType = convertTo(data);
        const fn = (v) => v === null || v === undefined ? v : castToType(v);
        return [name, fn];
    });
    return params => lodash_1.default.fromPairs(fields.map(([name, fn]) => [name, fn(params[name])]));
}
exports.buildConverter = buildConverter;
function buildWhere(configuration) {
    if (configuration.type === 'default') {
        const fields = configuration.inputColumns.map(({ name, variable }) => {
            if (variable === 'numerical') {
                return params => [name, { $numeric: params[name] }];
            }
            else {
                return params => [name, params[name]];
            }
        });
        return params => ({
            where: lodash_1.default.fromPairs(fields.map(f => f(params))),
        });
    }
    else {
        throw new Error(`Unknown PredictorConfiguration type: ${configuration.type}`);
    }
}
function buildPredict(target) {
    if (target.type === 'single-column') {
        return {
            predict: target.targetColumn.name,
        };
    }
    else {
        throw new Error(`Unknown PredictorTarget type: ${target.type}`);
    }
}
function buildTrainTest(settings, tableRows) {
    const testSetSize = lodash_1.default.min([
        settings.maxSamples,
        Math.round(tableRows * settings.sampleSplitRatio),
    ]) || 0;
    let modulo;
    if (testSetSize === 0) {
        modulo = 5;
    }
    else {
        modulo = Math.round(tableRows / testSetSize);
    }
    return {
        test: {
            $index: {
                $mod: [modulo, 1],
            },
        },
    };
}
exports.buildTrainTest = buildTrainTest;
function buildQueryTemplate(data, configuration, target) {
    const from = buildFrom(data);
    const applyWhere = buildWhere(configuration);
    const predict = buildPredict(target);
    return params => {
        const where = applyWhere(params);
        return {
            select: ['feature', 'field', '$p', '$why'],
            ...from,
            ...where,
            ...predict,
        };
    };
}
exports.buildQueryTemplate = buildQueryTemplate;
function buildEvaluationQuery(data, configuration, target, settings, tableRows) {
    const evaluateParams = lodash_1.default.fromPairs(configuration.inputColumns.map(c => [c.name, { $get: c.name }]));
    const evaluate = buildQueryTemplate(data, configuration, target)(evaluateParams);
    const trainTest = buildTrainTest(settings, tableRows);
    const selectRelevant = { select: Object.keys(AitoEvaluateResults_1.EvaluateResultsValidators) };
    return {
        ...trainTest,
        ...selectRelevant,
        evaluate,
    };
}
exports.buildEvaluationQuery = buildEvaluationQuery;
function buildSearchQuery(data, whereParams) {
    const from = buildFrom(data);
    return {
        ...from,
        ...whereParams,
    };
}
exports.buildSearchQuery = buildSearchQuery;
//# sourceMappingURL=querybuilder.js.map